module.exports = __webpack_public_path__ + "static/CORDLESS_HP-048c0aa2fb7b619131ac6a1d46b4a955.svg";